import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { PromotionApplied } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { IntClear } from '../Components';
const _PromotionApplied = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    root,
    form,
    options,
    radioName,
    selectName,
    disabled,
    state,
    ...rest
  } = props;
  return (
    <SectionWrapper
      title={getI18n('customerTag.promotionApplied.discountsapplied')}>
      <ItemWrapper title=''>
        <PromotionApplied
          disabled={disabled}
          radioName={radioName}
          selectName={selectName}
          treeOptions={options || []}
          {...rest}
        />
        <IntClear
          form={form}
          root={root}
          value={radioName}
          state={state}
          disabled={disabled}
        />
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _PromotionApplied;
